import script from "./ShopInfoView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopInfoView.vue?vue&type=script&lang=ts&setup=true"

import "./ShopInfoView.vue?vue&type=style&index=0&id=db384202&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db384202"]])

export default __exports__